import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserInfo } from '@/types/auth.types';
import { writeAuthTokenCookie, clearAuthTokenCookie } from '@/utils/authCookie';

interface AuthState {
  token: string | null;
  user: UserInfo | null;
  _hasHydrated: boolean;
  /** expiresSec：token 有效期（秒），用于设置 auth_token cookie 的 Max-Age；缺省走兜底。 */
  setToken: (token: string | null, expiresSec?: number) => void;
  setUser: (user: UserInfo | null) => void;
  setHasHydrated: (state: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      _hasHydrated: false,
      setToken: (token, expiresSec) => {
        // 同步维护 auth_token cookie，供无法自定义请求头的场景携带鉴权。
        if (token) {
          writeAuthTokenCookie(token, expiresSec);
        } else {
          clearAuthTokenCookie();
        }
        set({ token });
      },
      setUser: (user) => set({ user }),
      setHasHydrated: (state) => set({ _hasHydrated: state }),
      logout: () => {
        localStorage.removeItem('auth-storage');
        clearAuthTokenCookie();
        set({ token: null, user: null });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ token: state.token, user: state.user }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
        // 从 localStorage 恢复登录态后重新种 cookie（会话 cookie 关页即失，需重种保持一致）。
        if (state?.token) {
          writeAuthTokenCookie(state.token);
        }
      },
    }
  )
);
